import axiosNeuron from "api/axios";
import endpoints from "api/endpoints";

export default async function getAudioChunkTypes() {
  const url = endpoints.audioChunkTypes.default;
  const { data } = await axiosNeuron.get(`${url}?ps=9999`);
  return data;
}
